export default __webpack_public_path__ + "static/media/ic_insert_link_48px.9892d95e.svg";